module.exports = __webpack_public_path__ + "img/amz_amzcoinvault.dc8a93a.png";